import React from 'react';
import { PaginaKop } from './ZijMenu';

interface PageBannerProps {
  label: string;
  title: string;
  subtitle?: string;
  icon: React.ComponentType<{ size?: number; color?: string; className?: string }>;
  sidebarLine?: boolean;
  titleRight?: boolean;
  sidebarWidthClass?: string;
}

/**
 * Paginatitel voor routes zonder ZijMenu (BeLagom-huisstijl okt 2026): lichte
 * kop op de rustachtergrond i.p.v. de vroegere donkere band. sidebarLine /
 * titleRight / sidebarWidthClass zijn er nog voor compatibiliteit.
 */
export const PageBanner: React.FC<PageBannerProps> = ({ label, title, subtitle, icon: Icon }) => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
    <PaginaKop
      label={label}
      titel={title}
      ondertitel={subtitle}
      acties={
        <div className="hidden sm:flex w-11 h-11 rounded-xl bg-gold-100 border border-gold-200 items-center justify-center">
          <Icon size={20} color="#A06D14" />
        </div>
      }
    />
  </div>
);
